import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { updateDeliveryDetailsField, updateDeliveryDetailsValidity } from '../../../../actions/actions'
import { getDeliveryDetails } from '../../../../selectors/selectors'
import FormControl from '../FormControl/FormControl'

export default function NotLoggedInForm() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { values } = useSelector(getDeliveryDetails)
  const { register, errors, formState } = useForm({ mode: 'all', defaultValues: values })
  const validationRules = getValidationRules(t)

  useEffect(() => {
    dispatch(updateDeliveryDetailsValidity(formState.isValid))
  }, [dispatch, formState.isValid])

  return (
    <form>
      {['firstName', 'lastName', 'email'].map(name => (
        <FormControl
          error={formState.touched[name] && errors[name]}
          inputRef={register(validationRules[name])}
          key={name}
          label={t(`deliveryDetails.form.${name}.label`)}
          name={name}
          onChange={e => dispatch(updateDeliveryDetailsField({ name, value: e.target.value }))}
          touched={formState.touched[name]}
        />
      ))}
    </form>
  )
}

function getValidationRules(t) {
  const namePattern = /^[a-zöäüõžšŠåąčęėįšųūžāčēģīķļņūžōŗéáàë. -]*$/i
  const emailPattern = /^[_a-z0-9+-]+(\.[_a-z0-9+-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i

  const createValidationRules = ({ validationPattern, validationError }) => ({
    validate: value => {
      const trimmedValue = value.trim()

      if (!trimmedValue) return t('deliveryDetails.form.error.required')
      if (!validationPattern.test(trimmedValue)) return validationError
    },
    setValueAs: value => value.trim()
  })

  const nameValidationRules = createValidationRules({
    validationError: t('deliveryDetails.form.error.namePattern'),
    validationPattern: namePattern
  })

  const emailValidationRules = createValidationRules({
    validationError: t('deliveryDetails.form.error.emailPattern'),
    validationPattern: emailPattern
  })

  return {
    firstName: nameValidationRules,
    lastName: nameValidationRules,
    email: emailValidationRules
  }
}
